// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"892af230","239":"be0d2136","453":"abd36b29","732":"ab40904f"}[chunkId] + ".chunk.js";
};